// Copyright (c) 2016 Deere & Company

import DealerRecommendations from './components/dealer-recommendation';
import Facets from './state/facets';
import actionCreators from './action-creators';
import {connect} from 'react-redux';
import {getDateFormat} from '../../shared/services/get-date-format';
import reports from '../../routes/products/reports';

const getStateToBindToContainerProps = state => ({
    ...state.dealerRecommendationsReducer,
    dateFormat: getDateFormat(state.user.details.settings.general.dateFormat.key),
    duplicatePinPlateCount: state.factoryDuplicatePinPlate.factoryDuplicatePinPlates.length,
    facets: new Facets({
        ...state.dealerRecommendationsReducer.facets,
        dealerAccountsFacet: {
            ...state.dealerRecommendationsReducer.facets.dealerAccountsFacet,
            allowedDealers: state.user.details.settings.dealer.accounts.selectedAccounts
        }
    }),
    highRentalDaysCount: state.productSearch.highRentalDays.highdayscount,
    machineStatusUpdateCount: state.machineStatusUpdate.machineStatusUpdates.length,
    registrationReviewCount: state.registrationReview.registrations.length,
    reportsRoutes: reports(),
    searchResultsCount: state.productSearch.searchResults.length,
    security: state.user.security,
    selectedDealers: state.tcsm.wip.wipFacets.dealers,
    transferApprovalsCount: state.home.wip.productTracking.transferApprovals,
    user: state.user.details
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    }
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(DealerRecommendations);



// WEBPACK FOOTER //
// ./src/product/dealer-recommendations/state-connector.js